// src/redux/reducers/searchReducer.js

import { SET_SEARCH_QUERY } from "../actions";

const initialState = {
  query: "",
};

export const searchReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_SEARCH_QUERY:
      return {
        ...state,
        query: action.payload,
      };
    default:
      return state;
  }
};
